import * as yup from "yup";
import { localToString } from "../../utilities/StringUtil";

export const FormSchema = yup
  .object({
    playerOneProam: yup.boolean(),
    name: yup.string().required("Este campo es requerido"),
    lastname: yup.string().required("Este campo es requerido"),
    email: yup
      .string()
      .email("Ingrese un email valido")
      .required("Este campo es requerido"),
    phoneNumber: yup.string(),
    mobileNumber: yup.string().required("Este campo es requerido"),
    company: yup.string(),
    documentType: yup.number().required("Este campo es requerido"),
    documentNumber: yup.string().when("documentType", {
      is: 1,
      then: yup
        .string()
        .notOneOf(
          [
            yup.ref("guestDocument"),
            yup.ref("teamDocumentNumber"),
            yup.ref("teamGuestDocument"),
            null,
          ],
          "Esta cédula se está utilizando en el formulario.",
        )
        .length(11, "Cédula  invalida")
        .required("Este campo es requerido"),
      otherwise: yup
        .string()
        .notOneOf(
          [
            yup.ref("guestDocument"),
            yup.ref("teamDocumentNumber"),
            yup.ref("teamGuestDocument"),
            null,
          ],
          "Este pasaporte se está utilizando en el formulario.",
        )
        .required("Este campo es requerido"),
    }),
    sex: yup.number().required("Este campo es requerido"),
    tshirtSize: yup.number().required("Este campo es requerido"),
    ghin: yup
      .number()
      .test(
        "len",
        "Mínimo 6 números / Máximo 8 números",
        (val) =>
          localToString(val).length <= 8 && localToString(val).length >= 6,
      )
      .required("Este campo es requerido"),
    handicap: yup
      .number()
      .required("Este campo es requerido")
      .max(24, "El handicap maximo es 24"),
    diestro: yup.number().required("Este campo es requerido"),
    gloveSize: yup.number().required("Este campo es requerido"),
    guest: yup.string().required("Este campo es requerido"),
    guestName: yup.string().when("guest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    guestLastName: yup.string().when("guest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    guestDocumentType: yup.number().when("guest", {
      is: "1",
      then: yup.number().required("Este campo es requerido"),
      otherwise: yup.number(),
    }),
    guestDocument: yup.string().when("guest", {
      is: "1",
      then: yup.string().when("guestDocumentType", {
        is: 1,
        then: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              yup.ref("teamDocumentNumber"),
              yup.ref("teamGuestDocument"),
              null,
            ],
            "Esta cédula se está utilizando en el formulario.",
          ),
        otherwise: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              yup.ref("teamDocumentNumber"),
              yup.ref("teamGuestDocument"),
              null,
            ],
            "Este pasaporte se está utilizando en el formulario.",
          )
          .required("Este campo es requerido"),
      }),
      otherwise: yup.string(),
    }),
    guestEmail: yup.string().when("guest", {
      is: "1",
      then: yup
        .string()
        .email("Ingrese un email valido")
        .required("Este campo es requerido"),
      otherwise: yup.string(),
    }),

    playerTwoProam: yup.boolean(),
    teamName: yup.string().required("Este campo es requerido"),
    teamlastname: yup.string().required("Este campo es requerido"),
    teamEmail: yup
      .string()
      .email("Ingrese un email valido")
      .required("Este campo es requerido"),
    teamPhoneNumber: yup.string(),
    teamMobileNumber: yup.string().required("Este campo es requerido"),
    teamCompany: yup.string(),
    teamSex: yup.number().required("Este campo es requerido"),
    teamDocumentType: yup.number().required("Este campo es requerido"),
    teamDocumentNumber: yup.string().when("teamDocumentType", {
      is: 1,
      then: yup
        .string()
        .notOneOf(
          [
            yup.ref("documentNumber"),
            yup.ref("guestDocument"),
            yup.ref("teamGuestDocument"),
            null,
          ],
          "Esta cédula se está utilizando en el formulario.",
        ),
      otherwise: yup
        .string()
        .notOneOf(
          [
            yup.ref("documentNumber"),
            yup.ref("guestDocument"),
            yup.ref("teamGuestDocument"),
            null,
          ],
          "Este pasaporte se está utilizando en el formulario.",
        )
        .required("Este campo es requerido"),
    }),
    teamTshirtSize: yup.string().required("Este campo es requerido"),
    teamGhin: yup
      .number()
      .test(
        "len",
        "Mínimo 6 números / Máximo 8 números",
        (val) =>
          localToString(val).length <= 8 && localToString(val).length >= 6,
      )
      .required("Este campo es requerido"),
    teamHandicap: yup
      .number()
      .required("Este campo es requerido")
      .max(24, "El handicap maximo es 24"),
    teamDiestro: yup.number().required("Este campo es requerido"),
    teamGloveSize: yup.number().required("Este campo es requerido"),
    teamGuest: yup.string().required("Este campo es requerido"),
    teamGuestName: yup.string().when("teamGuest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    teamGuestLastName: yup.string().when("teamGuest", {
      is: "1",
      then: yup.string().required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
    teamGuestDocumentType: yup.number().when("teamGuest", {
      is: "1",
      then: yup.number().required("Este campo es requerido"),
      otherwise: yup.number(),
    }),
    teamGuestDocument: yup.string().when("teamGuest", {
      is: "1",
      then: yup.string().when("teamGuestDocumentType", {
        is: 1,
        then: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              yup.ref("guestDocument"),
              yup.ref("teamDocumentNumber"),
              null,
            ],
            "Esta cédula se está utilizando en el formulario.",
          ),
        otherwise: yup
          .string()
          .notOneOf(
            [
              yup.ref("documentNumber"),
              yup.ref("guestDocument"),
              yup.ref("teamDocumentNumber"),
              null,
            ],
            "Este pasaporte se está utilizando en el formulario.",
          )
          .required("Este campo es requerido"),
      }),
      otherwise: yup.string(),
    }),
    teamGuestEmail: yup.string().when("teamGuest", {
      is: "1",
      then: yup
        .string()
        .email("Ingrese un email valido")
        .required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
  })
  .required();

export type TRegisterBody = yup.InferType<typeof FormSchema>;
